/**
 * @generated SignedSource<<5e8ed80554ef4fa3ba045a3288d60774>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchAtlasProject_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultAtlasProject";
  readonly iconUrl: string | null;
  readonly id: string;
  readonly project: {
    readonly key: string;
  } | null;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"projectTitleMetadata_AtlassianSearchPage">;
  readonly " $fragmentType": "searchAtlasProject_AtlassianSearchPage";
};
export type searchAtlasProject_AtlassianSearchPage$key = {
  readonly " $data"?: searchAtlasProject_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchAtlasProject_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchAtlasProject_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "projectTitleMetadata_AtlassianSearchPage"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    },
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        }
      ]
    }
  ],
  "type": "SearchResultAtlasProject"
};

(node as any).hash = "ed519b41d1581401a0e4ff7c61f2fee0";

export default node;
